import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialSoundcloudIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialSoundcloud",
    children: /*#__PURE__*/_jsx("path", {
      d: "M32 19.07a4.49 4.49 0 0 1-4.54 4.23h-10.9c-.5 0-.9-.41-.9-.91V10.65c-.02-.41.22-.79.6-.96 0 0 1-.7 3.11-.7 1.29 0 2.56.35 3.67 1.01a7.22 7.22 0 0 1 3.41 4.73c.38-.11.76-.16 1.16-.16A4.36 4.36 0 0 1 32 18.91zM14.29 11.4c.02-.19-.12-.37-.31-.39s-.37.12-.39.31v.08c-.3 3.95-.53 7.65 0 11.58.02.19.2.33.39.31.16-.02.3-.15.31-.31.57-3.97.33-7.6 0-11.58M12.09 12.76c-.02-.2-.2-.35-.41-.33-.17.02-.31.16-.33.33-.4 3.4-.4 6.83 0 10.22.03.2.22.34.42.31a.36.36 0 0 0 .31-.31c.44-3.39.44-6.83 0-10.22ZM9.87 12.42c-.02-.2-.2-.34-.4-.32-.17.02-.3.15-.32.32-.34 3.6-.51 6.96 0 10.56 0 .2.16.35.35.35s.35-.16.35-.35c.52-3.64.36-6.91 0-10.56ZM7.67 13.44c0-.2-.16-.37-.37-.37s-.37.16-.37.37a37.2 37.2 0 0 0 0 9.54c.02.2.2.34.4.32.17-.02.3-.15.32-.32.44-3.17.45-6.38.01-9.54ZM5.45 15.83c0-.2-.16-.36-.36-.36s-.36.16-.36.36c-.53 2.46-.28 4.69.02 7.18a.35.35 0 0 0 .69 0c.33-2.52.58-4.71.02-7.18ZM3.24 15.45a.364.364 0 0 0-.41-.33c-.18.02-.32.16-.33.33-.46 2.51-.31 4.72.01 7.22.03.38.68.38.72 0 .36-2.54.53-4.69.01-7.23ZM1.02 16.68a.364.364 0 0 0-.41-.33c-.18.02-.31.16-.33.33-.43 1.69-.29 3.08.03 4.77.02.19.19.33.39.31a.36.36 0 0 0 .31-.31c.38-1.72.56-3.09.02-4.77Z"
    })
  }));
};
SocialSoundcloudIcon.displayName = 'SocialSoundcloudIcon';